import { TActions } from '../../types';
import { JOIN_FAIR_PLAY_FAIL, JOIN_FAIR_PLAY_SUCCESS } from './actions';
import { JOIN_FAIR_PLAY_START } from './actions/joinFairPlayStart';
import { EFairPlayStatus, IFairPlayState } from './types';

export const defaultState: IFairPlayState = {
  status: EFairPlayStatus.initial,
  errorCode: null,
  error: null,
};

export function fairPlay(state: IFairPlayState = defaultState, action: TActions): IFairPlayState {
  switch (action.type) {
    case JOIN_FAIR_PLAY_START: {
      return {
        ...state,
        status: EFairPlayStatus.pending,
        errorCode: null,
        error: null,
      };
    }

    case JOIN_FAIR_PLAY_SUCCESS: {
      return {
        ...state,
        status: EFairPlayStatus.success,
      };
    }

    case JOIN_FAIR_PLAY_FAIL: {
      const { errorCode, error } = action.payload;

      return {
        ...state,
        status: EFairPlayStatus.fail,
        errorCode,
        error,
      };
    }

    default:
      return state;
  }
}
